var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background",on:{"click":_vm.hide}},[_c('div',{staticClass:"frame"},[_c('overlay-title',{staticClass:"layout-title"}),_c('overlay-message')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }